import {Pipe, PipeTransform} from "@angular/core";
import {Marker} from "@models";

@Pipe({
	name: "markerFilter",
	pure: false,
	standalone: false,
})
export class MarkerFilterPipe implements PipeTransform {
	transform(markers: Marker[], value: "all" | "favs", userId?: string): Marker[] {
		if (!markers) {
			return [];
		}

		if (!value || value.length === 0) {
			return markers;
		}

		return markers.filter((marker) => {
			let showMarker = false;

			if (value === "favs") {
				showMarker = marker.isFavorited;
			} else {
				showMarker = true;
			}

			if (userId && showMarker) {
				showMarker = marker.userId === userId;
			}

			return showMarker;
		});
	}
}
